import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class EnrolleListService {

  constructor(private _http: HttpClient) {
  }

  // getContingentData(param) {
  //   return this._http.get<any>(`api/enrolls/getList/${param.collegeId}/${param.year}`);
  // }

  getAllList(param) {
    return this._http.post<any>(`api/enrolls/getList`, param);
  }

  getApplicationInfo(enrollId) {
    return this._http.post<any>(`api/enrolls/getApplicationInfo`, enrollId);
  }

  updateApplicationInfo(dto) {
    return this._http.post<any>(`api/enrolls/updateApplicationInfo`, dto);
  }

  getSubjectsForAdmission(enrollId) {
    return this._http.post<any>(`api/enrolls/getSubjectsForAdmission`, enrollId);
  }

  saveSubjectAdmissionDates(dto) {
    return this._http.post<any>(`api/enrolls/saveSubjectAdmissionDates`, dto);
  }

  publishEnrollApplication(dto, publishStatus: number) {
    return this._http.post<any>(`api/enrolls/publishEnrollApplication/${publishStatus}`, dto);
  }

  cancelPublishEnrollApplication(dto, publishStatus: number) {
    return this._http.post<any>(`api/enrolls/cancelPublishEnrollApplication/${publishStatus}`, dto);
  }

  generateExcel(page: any) {
    return this._http.post('api/enrolls/generateList/xls', page, {responseType: 'blob', observe: 'response'});
  }

  ranging(competitionResultType: number) {
    return this._http.post<any>(`api/enrolls/ranging/${competitionResultType}`, null);
  }

  fixedRanging(competitionResultType: number) {
    return this._http.post<any>(`api/enrolls/ranging/fixed/${competitionResultType}`, null);
  }

  getEnrollPublicList(param) {
    return this._http.post<any>(`api/enrolls/public/getList`, param);
  }

  getApplicantsPublicList(param) {
    return this._http.post<any>(`api/enrolls/public/getList/applicants`, param);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user/services/enrolle-list.service.ts